"use client";

import React, { useState } from "react";
import { ArrowUpDown, Search } from "lucide-react";
import { Modal } from "modules/common/components/Modal/Modal";
import { useSetFilters } from "modules/sets/hooks/useSetFilters";
import { SET_SORT_OPTIONS_MOBILE } from "modules/sets/constants/sortOptions";
import { MobileSearchGroup } from "modules/common/components/mainbar/MobileSearchGroup";
import {
  SortOptionsRadioGroup,
  SortDirectionRadioGroup,
} from "modules/common/components/mainbar/MobileSortControls";
import { MobileFilterBar } from "modules/common/components/MobileFilterBar";

export function SetMobileMainbar() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isSortOpen, setIsSortOpen] = useState(false);

  const { filters: req, setName, setSort, setOrder } = useSetFilters();

  // Local state for sort modal (synced when modal opens)
  const [localSort, setLocalSort] = useState(req.sort);
  const [localOrder, setLocalOrder] = useState(req.order);

  const [searchValue, setSearchValue] = useState(req.query || "");

  const handleSearchCommit = () => {
    setName(searchValue);
    setIsSearchOpen(false);
  };

  const handleSearchClear = () => {
    setSearchValue("");
    setName("");
    setIsSearchOpen(false);
  };

  const mobileActions = [
    {
      icon: <Search size={16} />,
      label: "Search",
      onClick: () => {
        setSearchValue(req.query || "");
        setIsSearchOpen(true);
      },
      active: !!req.query,
    },
    {
      icon: <ArrowUpDown size={16} />,
      label: "Sort",
      onClick: () => {
        setLocalSort(req.sort);
        setLocalOrder(req.order);
        setIsSortOpen(true);
      },
    },
  ];

  return (
    <>
      <MobileFilterBar actions={mobileActions} />

      {/* Search Modal */}
      <Modal
        open={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
        title="Search"
        height="auto"
        maxWidth="lg"
      >
        <div className="flex flex-col gap-6 py-2">
          <MobileSearchGroup
            value={searchValue}
            onChange={setSearchValue}
            onClear={handleSearchClear}
            placeholder="Search for a set..."
          />

          <div className="flex gap-2">
            <button
              className="btn btn-ghost flex-1"
              onClick={handleSearchClear}
            >
              Clear
            </button>
            <button
              className="btn btn-primary flex-1"
              onClick={handleSearchCommit}
            >
              Apply
            </button>
          </div>
        </div>
      </Modal>

      {/* Sort Modal */}
      <Modal
        open={isSortOpen}
        onClose={() => setIsSortOpen(false)}
        title="Sort"
        height="auto"
        maxWidth="lg"
      >
        <div className="flex flex-col gap-6 py-2">
          <SortOptionsRadioGroup
            options={SET_SORT_OPTIONS_MOBILE}
            currentSort={localSort}
            onSortChange={setLocalSort}
            label=""
          />
          <SortDirectionRadioGroup
            currentOrder={localOrder}
            onOrderChange={setLocalOrder}
          />
          <div className="flex gap-2">
            <button
              className="btn btn-ghost flex-1"
              onClick={() => setIsSortOpen(false)}
            >
              Close
            </button>
            <button
              className="btn btn-primary flex-1"
              onClick={() => {
                setSort(localSort);
                setOrder(localOrder);
                setIsSortOpen(false);
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
